import { render, staticRenderFns } from "./shipmentCharges.vue?vue&type=template&id=a1d67a06&scoped=true"
import script from "./shipmentCharges.vue?vue&type=script&lang=js"
export * from "./shipmentCharges.vue?vue&type=script&lang=js"
import style0 from "./shipmentCharges.vue?vue&type=style&index=0&id=a1d67a06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d67a06",
  null
  
)

export default component.exports